export enum Role {
  CUSTOMER = 'CUSTOMER',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  BRANCH_ADMIN = 'BRANCH_ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  /** B2B buyer: places carts, orders and requisitions for its branch. */
  PROCUREMENT = 'PROCUREMENT',
  /** B2B warehouse: picks, packs, ships and receives transfers. */
  WAREHOUSE_STAFF = 'WAREHOUSE_STAFF',
  /** B2B finance: invoices, payments and credit. */
  FINANCE = 'FINANCE',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

/**
 * The B2B separation-of-duties roles. They sign in to the B2B app, not to
 * this panel (the panel login admits only the three admin roles), and are
 * peers: none of them can create or assign roles.
 */
export const B2B_ROLES: readonly Role[] = [
  Role.PROCUREMENT,
  Role.WAREHOUSE_STAFF,
  Role.FINANCE
];

export const isB2BRole = (role: string | undefined | null): boolean =>
  !!role && (B2B_ROLES as readonly string[]).includes(role);

/**
 * Roles that work at one branch and are linked to it (backend
 * `BRANCH_LINKED_ROLES` minus BRANCH_ADMIN): the employee and the three B2B
 * roles. A user of these roles needs a branch, like an employee.
 */
export const isBranchStaffRole = (role: string | undefined | null): boolean =>
  role === Role.EMPLOYEE || isB2BRole(role);
